const config = {
  CATEGORY_INTERFERE: "interfere",
  CATEGORY_ALL: "notice",
  STATUS_NEW: 0,
  STATUS_DELIVERED: 1,
  STATUS_VIEWED: 2,
  STATUS_APPROVED: 3,
  STATUS_DECLINED: 4,
  statusLabels: {
    0: "Новое",
    1: "Доставлено",
    2: "Прочитано",
    3: "Принято",
    4: "Отклонено",
  },
};
export default config;
